import { Component, forwardRef, input, model } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

import { isNil } from '@gfe/core/utils/shared-utils';

import {
  FieldNumber,
  FormBuilderBase
} from '@shared/components/row-edition-form/form-builder/form-builder.model';

import { getAsNullIfEmpty, unwrapValue } from '../row-edition-form.utils';

@Component({
  selector: 'app-number',
  imports: [],
  templateUrl: './number.component.html',
  styles: [
    `
      :host {
        display: flex;
        width: 100%;
      }
    `
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NumberComponent),
      multi: true
    }
  ]
})
export class NumberComponent implements ControlValueAccessor {
  id = input<FormBuilderBase['id']>();
  value = model.required<number | null>();
  max = input<FieldNumber['max']>();
  min = input<FieldNumber['min']>();
  step = input<FieldNumber['step']>();
  placeholder = input<number>();
  required = input<FormBuilderBase['required']>();
  wrapperProperty = input<string | undefined>(undefined);

  onChange = (_value: string | number | null) => {};
  onTouched = () => {};

  onInput(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    if (isNil(getAsNullIfEmpty(value))) {
      this.onChange(null);
      return;
    }
    if (isNaN(Number(value))) {
      this.onChange(value);
    } else {
      this.onChange(Number(value));
    }
  }

  writeValue(value: number): void {
    this.value.set(unwrapValue(value, this.wrapperProperty()) as number);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  registerOnChange(fn: any): void {
    this.onChange = (value: string | number | null) =>
      fn(unwrapValue(value, this.wrapperProperty()));
  }
  registerOnTouched(fn: never): void {
    this.onTouched = fn;
  }
}
